<template>
  <div class="schedule-container">
    <button type="button" aria-label="Close" class="el-dialog__headerbtn" @click="sendDataToParent">
      <i class="el-dialog__close el-icon el-icon-close"></i>
    </button>
    <div class="schedule-title">{{$t('fundingSchedule')}}</div>

    <div class="schedule-item_box">
      <div class="schedule-item">
        <div class="schedule-label">{{$t('settlementCycle')}}</div>
        <div class="schedule-value">{{$t('twentyFourHours')}}</div>
      </div>

      <div class="schedule-item">
        <div class="schedule-label">{{$t('fundingFee')}}</div>
        <div>
          <span class="yq">{{symbol.substr(0,1)}}</span>
          <span class="schedule-value">{{symbol}}</span>
        </div>
      </div>

      <div class="schedule-item">
        <div class="schedule-label">{{$t('openAmount')}}</div>
        <div class="open-amount-container">
          <input type="number" class="open-amount-input" @input="changeAmount" :disabled="false" v-model="openAmount" value="0">
          <span class="btc-label">{{name}}</span>
        </div>
      </div>
    </div>

    <div class="phase-grid">
      <div>
        <div class="phase-title">{{$t('phase0')}}</div>
        <div class="phase-box">{{p0}}</div>
      </div>
      <div>
        <div class="phase-title">{{$t('phase1')}}</div>
        <div class="phase-box">{{p1}}</div>
      </div>
      <div>
        <div class="phase-title">{{$t('phase2')}}</div>
        <div class="phase-box">{{p2}}</div>
      </div>
      <div>
        <div class="phase-title">{{$t('phase3')}}</div>
        <div class="phase-box">{{p3}}</div>
      </div>
      <div>
        <div class="phase-title">{{$t('phase4')}}</div>
        <div class="phase-box">{{p4}}</div>
      </div>
      <div>
        <div class="phase-title">{{$t('phase5')}}</div>
        <div class="phase-box">{{p5}}</div>
      </div>
    </div>

    <div class="phase-text">{{$t('phasesToHoldPosition')}}</div>
    <div class="schedule-item">
      <input type="text" class="phases-input" v-model="inputDay" value="">
      <div class="schedule-label" style="color: #ffffff;position: absolute;left: 110px;">Phases</div>
      <div class="schedule-value">{{total}} <span style="color: #848E9C">{{symbol}}</span></div>
    </div>
  </div>
</template>

<script>
import {Contract, Method} from "../config/const";
import {createAndCall, createLeadingContractAndCall} from "../utils/contract";
import {transBig2number, transNumber2Big} from "../utils/functions";
import {cacheData, getCache} from "../service/cacheService";

export default {
  name: 'DraggableProgress',
  props: {
    dataValue: {
      type: Object,
      default: {},
    },
    dataNumber: {
      type: Number,
      default: 0,
    },
    contractAddress:{
      type:String,
      default:""
    },
    price:{
      type:String,
      default:""
    },
    price2:{
      type:String,
      default:""
    },
    decimals:{
      type:Number,
      default:18
    }
  },
  data() {
    return {
      number:this.dataNumber,
      openAmount:0,
      p0:0,
      p1:0,
      p2:0,
      p3:0,
      p4:0,
      p5:0,
      symbol:"",
      total:0,
      rate:[],
      inputDay:6,
      fundingFee:0,
      name:"BTC",

    };
  },
  watch: {
    inputDay(val){
      let total=0;
      for(let i =0 ;i<val;i++){
        total+=parseFloat(transBig2number(this.rate[i]))*this.fundingFee;
      }
      this.total=total.toFixed(2);
    },

  },
  methods: {
    changeAmount(){
      this.calcuAgain();
    },
    sendDataToParent() {
      this.$emit('custom-event', { message: this.number });
    },
    async getData(){
      // let res=await createAndCall(Contract.PerpetualOptions,Method.getFundingFeeRateMatrix);
    },
    async calcuAgain(){
      console.log("cacu is",this.openAmount,this.price);
      let openPrice="";
      if(this.type==1){
        openPrice=this.price;
      }else{
        openPrice=this.price2;
      }
      let estimateFee=await createLeadingContractAndCall(this.contractAddress,Method.estimateTradeFee,false,transNumber2Big(this.openAmount),transNumber2Big(openPrice),this.name);
      let funding="";
      if(estimateFee[1]){
        funding=transBig2number(estimateFee[1],parseInt(this.decimals));
      }
      console.log("found ing is",funding);
      await this.setAndCalcu("",funding,"","")
    },
    async setAndCalcu(amount,fundingFee,symbol,name,type=0){
      if(name){
        this.name=name;
      }
      if(fundingFee){
        this.fundingFee=fundingFee
      }
      if(amount){
        this.openAmount=amount;
      }
      // let res=getCache("funding_fee_matrix");
      // if(res){
      //   res=await createAndCall(Contract.PerpetualOptions,Method.getFundingFeeRateMatrix);
      //   console.log("rate is",res[0].toString());
      //   cacheData("funding_fee_matrix",res,0);
      // }
      // this.rate=res;
      // this.p0=(parseFloat(transBig2number(res[0]))*fundingFee).toFixed(2);
      // this.p1=(parseFloat(transBig2number(res[1]))*fundingFee).toFixed(2);
      // this.p2=(parseFloat(transBig2number(res[2]))*fundingFee).toFixed(2);
      // this.p3=(parseFloat(transBig2number(res[3]))*fundingFee).toFixed(2);
      // this.p4=(parseFloat(transBig2number(res[4]))*fundingFee).toFixed(2);
      // this.p5=(parseFloat(transBig2number(res[5]))*fundingFee).toFixed(2);
      //
      // this.total=(parseFloat(this.p0)+parseFloat(this.p1)+parseFloat(this.p2)+parseFloat(this.p3)+parseFloat(this.p4)+parseFloat(this.p5)).toFixed(2);
      // if(symbol){
      //   this.symbol=symbol;
      // }
      // if(type){
      //   this.type=type;
      // }
    }
  },
  mounted() {
    this.getData()
  },

};
</script>

<style scoped lang="scss">
.schedule-container {
  background: #1E2329;
  padding: 20px;
  border-radius: 10px;
  width: 350px;
  box-sizing: border-box;
  color: #848E9C;
  position: absolute;
  z-index: 999;
}

.schedule-title {
  font-size: 16px;
  font-weight: 500;
  margin-bottom: 20px;
  color: #ffffff;
}

.schedule-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
}

.schedule-label {
  font-size: 14px;
  color: #848E9C;
}

.schedule-value {
  font-size: 14px;
  color: #ffffff;
}

.phase-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 10px;
  margin-top: 20px;
}

.phase-box {
  width: 94.73px;
  height: 30px;
  opacity: 1;
  border-radius: 6px;
  background: #181A20;
  border: 1px solid #181A20;
  font-size: 15px;
  font-weight: 500;
  letter-spacing: 0px;
  line-height: 30px;
  color: rgba(198, 254, 97, 1);
  text-align: center;
}


.open-amount-container {
  display: flex;
  width: 137px;
  height: 30px;
  opacity: 1;
  border-radius: 6px;
  background: #151718;
  align-items: center;
  border: 1px solid #848E9C;
  font-size: 14px;
.open-amount-input {
  border: none;
  padding: 8px;
  color: #848E9C;
  width: 80px;
  background-color: transparent;
  outline: none;
}
}



.btc-label {
  color: #848E9C;
  margin-left: 5px;
}

.phases-input {
  width: 79.77px;
  height: 38px;
  opacity: 1;
  border-radius: 6px;
  background: #181A20;
  border: 0;
  outline: none;
  color: #ffffff;
  padding: 0 8px;
  box-sizing: border-box;
}
.yq{
  display: inline-block;
  border: 2px solid white;
  border-radius: 50%;
  width: 22px;
  font-size: 14px;
  text-align: center;
  line-height: 22px;
  height: 22px;
  color: #ffffff;
  margin-right: 20px;
}
.schedule-item_box{
  background-color: #181A20;
  padding: 8px 8px 8px 8px;
  box-sizing: border-box;
  border-radius: 6px;

}
.phase-title{
  color: #848E9C;
  text-align: center;
  margin-bottom: 8px;
}
.phase-text{
  margin-top: 20px;
  color: #ffffff;
  margin-bottom: 12px;
}
::v-deep .el-dialog__headerbtn .el-dialog__close:hover{
  color: #ffffff;
}
</style>
